import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useKeycloak } from '@State/Keycloak/KeycloakProvider';
import { getEffectivePathFromWindow, isPrivatePath, isPublicPath } from './routeUtils';

const RedirectToLogin = () => {
  const { keycloak, initialized } = useKeycloak();
  const location = useLocation();

  useEffect(() => {
    if (!initialized) return;

    const effectivePath = getEffectivePathFromWindow(location.pathname);

    if (isPublicPath(effectivePath)) return;

    if (!isPrivatePath(effectivePath)) return;

    // Inte window.location.href: efter inloggningens hash-fix är adressen
    // "/#" med tom hash, och Keycloak lägger sina parametrar direkt efter
    // "#" (…/#&state=…&code=…). keycloak-js lämnar då "#&" kvar, routern
    // gör "/&/&" av det och användaren hamnar på 404. Med routerns sökväg i
    // hashen blir svaret "/#/&state=…" som rensas till "/#/".
    const { origin, pathname, search } = window.location;
    keycloak.redirectUri = `${origin}${pathname}${search}#${effectivePath}`;
    keycloak.createLoginUrl().then((loginUrl) => {
      window.location.href = loginUrl;
    });
  }, [initialized, location.pathname, location.hash, keycloak]);

  return null;
};

export default RedirectToLogin;
